"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    toolbarGroupClassNames: function() {
        return toolbarGroupClassNames;
    },
    useToolbarGroupStyles_unstable: function() {
        return useToolbarGroupStyles_unstable;
    }
});
const _react = require("@griffel/react");
const toolbarGroupClassNames = {
    root: 'fui-ToolbarGroup'
};
const useToolbarGroupStyles_unstable = (state)=>{
    state.root.className = (0, _react.mergeClasses)(toolbarGroupClassNames.root, state.root.className);
    return state;
}; //# sourceMappingURL=useToolbarGroupStyles.styles.js.map
